import { RoundedBox } from '@react-three/drei'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { solarCellThickness } from '../../model/helper/verandaDimensions'
import { FrontGlassMaterial } from './material/FrontGlassMaterial'

interface Props {
  positionX: number
}

export const BackGlassPanel = ({ positionX }: Props): JSX.Element => {
  const {
    roofLogWidth,
    userWidth,
    verandaTyp,
    polesTopNumber,
    schwelleSize,
    isQubus,
  } = useMeasures()
  const roofWidth = userWidth / (polesTopNumber - 1)
  const length =
    roofLogWidth +
    schwelleSize.depth +
    (isQubus ? verandaTyp.log.width : schwelleSize.depth)
  return (
    <>
      <RoundedBox
        args={[
          roofWidth -
            verandaTyp.roofBar.depth / 2 -
            (positionX ? 0 : verandaTyp.roofBar.depth),
          0.008,
          roofLogWidth + 0.07,
        ]}
        position={[0, -solarCellThickness - 0.004, length / 2]}
        radius={0.0005}
        smoothness={0.5}
        castShadow={false}
        receiveShadow={false}
        matrixWorldAutoUpdate={undefined}
        getObjectsByProperty={undefined}
        getVertexPosition={undefined}
      >
        {/*  TODO: Damit AR funktioniert verwende ich hier das gleiche Material. Da es ein limit von max 2 transparenten Materialien gibt */}
        <FrontGlassMaterial />
      </RoundedBox>
    </>
  )
}
